var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import Table from '../table';
import Spin from '../spin';
import { withResizeDetector } from './resize-detector';
import { logger, _ } from 'oss-toolkits';
// const isBrowser = typeof window !== 'undefined';
// const { logger, _ } = isBrowser ? require('oss-web-toolkits') : { logger: undefined, _: undefined };
const noop = () => { };
const computeState = ({ pageSize }, { direction, scrollTop, scrollHeight, tableHeight, visibleHeight, cacheSize }) => {
    if (scrollHeight === 0) {
        return {
            startIndex: 0,
            bottomPlaceholderHeight: 0,
            topPlaceholderHeight: 0,
        };
    }
    // 行高
    const rowHeight = tableHeight / pageSize;
    // 可视 高度
    const visibleRowCount = Math.round(visibleHeight / rowHeight);
    // 可视化起始位置计算
    let startIndex = Math.round((scrollTop / scrollHeight) * cacheSize);
    if (direction === 'up') {
        // 向上滚动 一屏数据
        startIndex -= pageSize - visibleRowCount;
        startIndex = startIndex < 0 ? 0 : startIndex;
    }
    else {
        startIndex = startIndex + pageSize > cacheSize ? cacheSize - pageSize : startIndex;
    }
    // 底部占位符高度计算
    const bottomPlaceholderHeight = Math.round((cacheSize - (startIndex + pageSize)) * rowHeight);
    startIndex = startIndex > 0 ? startIndex : 0;
    // 顶部占位符高度
    const topPlaceholderHeight = Math.round(startIndex * rowHeight);
    return {
        visibleRowCount,
        startIndex,
        bottomPlaceholderHeight,
        topPlaceholderHeight,
    };
};
class VirtualTable extends PureComponent {
    constructor(props) {
        super(props);
        // 顶部占位
        this.refTopPlaceholder = null;
        // 底部占位
        this.refBottomPlaceholder = null;
        // 滚动条
        this.refScroll = null;
        this.refTable = null;
        this.ioTargetState = {
            refBottomPlaceholder: null,
            refTopPlaceholder: null,
            refTable: null,
        };
        this.updateTable = () => {
            const { clientHeight: tableHeight } = this.refTable;
            const { scrollHeight, clientHeight: visibleHeight } = this.refScroll;
            const { isPropsChange } = this.state;
            if (!isPropsChange) {
                // fix bug: 当直接传入的dataSource数据量很大，无法滚动的问题。常见于不是按每页大小递增的情况，如1000条已有数据不需loading直接虚拟滚动显示的时候
                // 如果 isPropsChange === true 则下面的情况是合理的，不能退出state计算，要求重新计算
                if (
                // fix bug: 可能存在DOM更新时空白的情况，此种无效状态，需要过虑掉， （tableHeight 是很大的值，而this.state.tableHeight只是一个初始小值）
                (this.state.tableHeight && Math.abs(tableHeight - this.state.tableHeight) > 200) || // 容许正常误差
                    (this.state.scrollHeight && Math.abs(scrollHeight - this.state.scrollHeight) > 200) ||
                    (this.state.visibleHeight && visibleHeight !== this.state.visibleHeight)) {
                    logger.default.debug(`this.state.visibleHeight: ${this.state.visibleHeight}`);
                    logger.default.debug(`this.state.tableHeight: ${this.state.tableHeight}`);
                    logger.default.debug(`this.state.scrollHeight: ${this.state.scrollHeight}`);
                    return;
                }
            }
            this.setState(Object.assign(Object.assign({}, computeState(this.props, Object.assign(this.state, {
                direction: this.refScroll.scrollTop - this.state.scrollTop < 0 ? 'up' : 'down',
                scrollTop: this.refScroll.scrollTop,
                visibleHeight,
                scrollHeight,
                tableHeight,
            }))), { isPropsChange: false }));
        };
        this.state = {
            cacheSize: 0,
            scrollTop: 0,
            scrollHeight: 0,
            tableHeight: 0,
            visibleHeight: 0,
            visibleRowCount: 0,
            startIndex: 0,
            bottomPlaceholderHeight: 0,
            topPlaceholderHeight: 0,
            isPropsChange: false,
            direction: 'up',
        };
    }
    static PlaceHolder({ height, domNode, loading, loadingControl }) {
        return (domNode &&
            ReactDOM.createPortal(<div style={{ height: `${height}px` }}>{loading && loadingControl} </div>, domNode));
    }
    static getDerivedStateFromProps({ pageSize, dataSource: { length }, loading }, prevState) {
        const { tableHeight, scrollHeight: prevStateScrollHeight, visibleRowCount, cacheSize } = prevState;
        if (pageSize < visibleRowCount) {
            logger.default.warn(`pagesize(${pageSize}) less than visible row count(${visibleRowCount})!`);
        }
        const rowHeight = tableHeight / pageSize;
        const increase = length - cacheSize;
        let scrollHeight = Math.round(prevStateScrollHeight + increase * rowHeight);
        if (!loading) {
            scrollHeight = length * rowHeight;
        }
        if (pageSize < increase) {
            logger.default.warn(`increase(${increase}) greater than pageSize(${pageSize}) `);
        }
        return Object.assign(Object.assign({}, computeState({ pageSize }, Object.assign(prevState, {
            cacheSize: length,
            scrollHeight,
        }))), { isPropsChange: true });
    }
    componentDidMount() {
        this.refScroll =
            ReactDOM.findDOMNode(this).getElementsByClassName('oss-ui-table-body')[0] ||
                ReactDOM.findDOMNode(this);
        this.refTable = this.refScroll.getElementsByTagName('tbody')[0];
        this.createBottomPlaceholder();
        this.createTopPlaceholder();
        this.setStateWithThrottle = _.throttle(this.updateTable, 200);
        this.props.onScroll && this.refScroll.addEventListener('scroll', this.props.onScroll);
        if (this.refScroll) {
            this.io = new IntersectionObserver((changes) => {
                this.refScroll.removeEventListener('scroll', this.setStateWithThrottle);
                if (this.state.scrollTop && Math.abs(this.refScroll.scrollTop - this.state.scrollTop) < 20) {
                    // fix bug: 如果滚动步长小于20象素不做处理
                    return;
                }
                this.ioTargetState = changes.reduce((result, change) => {
                    const ret = Object.assign({}, result);
                    switch (change.target) {
                        case this.refBottomPlaceholder:
                            ret.refBottomPlaceholder = change;
                            break;
                        case this.refTopPlaceholder:
                            ret.refTopPlaceholder = change;
                            break;
                        case this.refTable:
                            ret.refTable = change;
                            break;
                        default:
                            logger.default.warn('Miss match dom');
                    }
                    return ret;
                }, this.ioTargetState);
                let mutation = 'cache scrolling';
                const { refBottomPlaceholder, refTopPlaceholder, refTable } = this.ioTargetState;
                const { startIndex, visibleRowCount, cacheSize } = this.state;
                const { loading, pageSize } = this.props;
                if (refBottomPlaceholder.intersectionRatio > 0) {
                    if (refTable.intersectionRatio > 0 &&
                        startIndex + pageSize + visibleRowCount >= cacheSize &&
                        !loading) {
                        // 已滚动到最后，加载数据
                        mutation = 'end';
                        logger.default.debug(mutation);
                        return this.setState({
                            scrollTop: this.refScroll.scrollTop,
                            scrollHeight: this.refScroll.scrollHeight,
                            tableHeight: this.refTable.clientHeight,
                        }, () => {
                            this.props.onFetch && this.props.onFetch(cacheSize);
                        });
                    }
                    else if (refTable.intersectionRatio > 0) {
                        mutation = 'down';
                    }
                    else if (refTable.intersectionRatio === 0) {
                        mutation = 'down nothing'; // 滚动到没有任何数据显示的区域
                    }
                }
                else if (refTopPlaceholder.intersectionRatio > 0) {
                    if (refTopPlaceholder.intersectionRatio === 1) {
                        mutation = 'top'; // 滚动到顶了
                    }
                    else if (refTable.intersectionRatio > 0) {
                        mutation = 'up'; // 滚动到显示的数据头部
                    }
                    else if (refTable.intersectionRatio === 0) {
                        mutation = 'up nothing'; // 滚动到没有任何数据显示的区域
                    }
                }
                // 既 看不到 refTopPlaceholder，refBottomPlaceholder 也看不到 refTable 表示 表格已被隐藏
                else if (refTable.intersectionRatio === 0) {
                    logger.default.debug('Bug: IntersectionObserver miss, because which waiting for Idle trigger');
                    const { height } = this.props;
                    // fix bug: 关闭监听
                    this.toggleObserver(false);
                    if (height > 0) {
                        this.toggleObserver();
                    }
                    return;
                }
                logger.default.debug(mutation);
                // 补充逻辑 防止出现 大片placeHolder
                if (mutation.includes('nothing')) {
                    this.refScroll.addEventListener('scroll', this.setStateWithThrottle);
                }
                this.setStateWithThrottle();
            }, {
                root: this.refScroll,
                threshold: [0, 0.25, 0.5, 0.75, 1],
                // threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
            });
            this.toggleObserver();
        }
    }
    componentWillUnmount() {
        if (this.refScroll) {
            this.props.onScroll && this.refScroll.removeEventListener('scroll', this.props.onScroll);
            this.refScroll.removeEventListener('scroll', this.setStateWithThrottle);
        }
        this.io.disconnect();
    }
    // 创建底部填充块
    createBottomPlaceholder() {
        const refBottomPlaceholder = document.createElement('div');
        refBottomPlaceholder.setAttribute('id', 'refBottomPlaceholder');
        this.refScroll.appendChild(refBottomPlaceholder);
        this.refBottomPlaceholder = refBottomPlaceholder;
    }
    // 创建顶部填充块
    createTopPlaceholder() {
        const refTopPlaceholder = document.createElement('div');
        refTopPlaceholder.setAttribute('id', 'refTopPlaceholder');
        this.refScroll.insertBefore(refTopPlaceholder, this.refScroll.firstChild);
        this.refTopPlaceholder = refTopPlaceholder;
    }
    toggleObserver(condition = true) {
        if (condition) {
            this.io.observe(this.refTopPlaceholder);
            this.io.observe(this.refBottomPlaceholder);
            this.io.observe(this.refTable);
        }
        else {
            this.io.unobserve(this.refTopPlaceholder);
            this.io.unobserve(this.refBottomPlaceholder);
            this.io.unobserve(this.refTable);
        }
    }
    getSnapshotBeforeUpdate(prevProps, prevState) {
        // 我们是否在 list 中添加新的 items ？
        // 捕获滚动​​位置以便我们稍后调整滚动位置。
        const list = this.refScroll;
        if (prevProps.dataSource.length < this.props.dataSource.length && this.refScroll) {
            return list.scrollTop;
        }
        return null;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        // 如果我们 snapshot 有值，说明我们刚刚添加了新的 items，
        // 调整滚动位置使得这些新 items 不会将旧的 items 推出视图。
        //（这里的 snapshot 是 getSnapshotBeforeUpdate 的返回值）
        if (snapshot !== null) {
            const list = this.refScroll;
            // list.scrollTop = list.scrollHeight - snapshot;
            list.scrollTop = snapshot;
            if (prevState.scrollTop !== list.scrollTop) {
                this.updateTable();
            }
        }
        if (prevProps.height === 0 && this.props.height > 0) {
            this.toggleObserver(false);
            this.toggleObserver();
        }
    }
    scrollToTop() {
        this.refScroll.scrollTop = 0;
        this.updateTable();
    }
    render() {
        const _a = this.props, { dataSource = [], pageSize, loadingControl, loading, modalContainer, size } = _a, rest = __rest(_a, ["dataSource", "pageSize", "loadingControl", "loading", "modalContainer", "size"]);
        const { startIndex, topPlaceholderHeight, bottomPlaceholderHeight } = this.state;
        return (<div className="oss-ui-virtual-table">
                <VirtualTable.PlaceHolder height={topPlaceholderHeight} domNode={this.refTopPlaceholder}/>
                <VirtualTable.PlaceHolder height={bottomPlaceholderHeight} domNode={this.refBottomPlaceholder} loading={loading} loadingControl={loadingControl}/>
                <Table size={size} bordered {...rest} dataSource={dataSource.slice(startIndex, startIndex + pageSize)} pagination={false} getPopupContainer={() => {
                return modalContainer;
            }}/>
            </div>);
    }
}
VirtualTable.defaultProps = {
    // loading 效果， A visual react component for Loading status
    loadingControl: (<div style={{
            textAlign: 'center',
            paddingTop: 20,
            paddingBottom: 20,
        }}>
                <Spin tip="数据加载中..."/>
            </div>),
    onScroll: null,
    onFetch: noop,
    loading: false,
    pageSize: 30,
    dataSource: [],
};
const VirtualTableWithResizeDetector = withResizeDetector(VirtualTable);
const VirtualTableForward = React.forwardRef((props, ref) => (<VirtualTableWithResizeDetector {...props} forwardedRef={ref}/>));
export { VirtualTableForward as VirtualTable };
export default VirtualTableForward;
